import * as _ from "lodash";
import {IHttpService, ILogService} from "angular";

export interface IReferenceDataItem {
    id: string;
    description: string;
}

export class ReferenceData {

    private refData: Map<string, IReferenceDataItem[]>;

    /* @ngInject */
    constructor(private $http: IHttpService, private $log: ILogService) {
        $log.info("ReferenceData constructed");
    }

    public init() {
        this.$log.info("ReferenceData init()");
        return this.$http.get("/api/common/reference-data")
            .then((response) => {
                this.refData = response.data as Map<string, IReferenceDataItem[]>;
                return this.refData;
            });
    }

    public getAll(type: string): IReferenceDataItem[] {
        return _.clone(this.getAllInternal(type));
    }

    public get(type: string, id: string): IReferenceDataItem {
        return _.clone(this.getObject(type, id));
    }

    // Get the corresponding description or else return the id back
    public getDescription(type: string, id: string): string {
        if (_.isNil(id)) {
            return id;
        }

        return _.get(this.getObject(type, id), "description", id);
    }


    // Internal methods return pointers to source objects. Public methods return copies to avoid source corruption/mutation.
    private getObject(type: string, id: string) {
        const referenceDataForType = this.getAllInternal(type);
        return _.find(referenceDataForType, {id: id});
    }

    private getAllInternal(type: string): IReferenceDataItem[] {
        if (_.isNil(this.refData)) {
            this.$log.error("Reference data has not been initialised. Initialise in ui-router using init() in a top-level route.");
            return undefined;
        }
        return this.refData[type];
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/reference-data/reference-data.service.ts